import * as types from '../action-types';

export default addressId => ({
  type: types.SET_ADDRESS_AS_EDITED, addressId,
});
